import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TProps, IDeps } from './models';
import { ConditionalDisplay as Component } from './component';

/**
 * Условное отображение
 * */
export const SmePartnersCommonConditionalDisplay = createWidget<IDeps, TProps>({})(Component);
